export default __webpack_public_path__ + "static/media/hht2_ep14_timeline_q04_b.52b4af9d.png";